import { chain } from 'lodash';
import { articleStyle } from './articleStyle';

/**
 * Similar to ArticleList or UrlList, but with no URL linking.
 *
 * Maps through the passed articles, and creates a list of the value in "fieldName".
 */
export const ObjectFieldList = ({
  articles,
  fieldName,
}: {
  articles: any;
  fieldName: string;
}) => {
  //map through the articles grabbing values
  const itemList = chain(articles)
    .map(article => article?.[fieldName])
    .value();

  if (itemList.length === 0) {
    return <>-</>;
  }

  return (
    //returns supercedence values in a new line
    <ul style={{ listStyleType: 'none', padding: 0 }}>
      {itemList.map((item, index) => (
        <li
          key={`${fieldName}-item-${item}-${index}`}
          style={{ ...articleStyle.li }}
        >
          {item || '-'}
        </li>
      ))}
    </ul>
  );
};
